import { render } from "./ed-atom-enquiry-status-icon.vue?vue&type=template&id=3c3104e0&scoped=true"
import script from "./ed-atom-enquiry-status-icon.vue?vue&type=script&lang=js"
export * from "./ed-atom-enquiry-status-icon.vue?vue&type=script&lang=js"

import "./ed-atom-enquiry-status-icon.vue?vue&type=style&index=0&id=3c3104e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3104e0"]])

export default __exports__